import { Button, CircularProgress, Divider, Paper, Typography } from "@mui/material"
import { CustomFormField } from "../../../../utilis/component/CustomFormElement"
import { Close, Save } from "@mui/icons-material"
import { useForm } from "react-hook-form"
import { FormOnChangeEventType } from "../../../../EMR/types"
import { useEffect, useState } from "react"
import { useMutation } from "react-query"
// import { getInsuranceType as fetchInsuranceType,getInsurances } from "../../../Insurance/ClaimListing/services";
// import { getInsuranceType as fetchInsuranceType, getInsurances } from "../../../../Insurance/ClaimListing/services"

import { MasterTableDataType, SaveReference } from "./type"
import { getAllCptGrpups, getInsPlanService, getNetwork, saveInsurancePriceMaster,getAllInsuraceType,getAllInsurance } from "../service"
import { clinicId } from "../../../../constants"
import usePopup from "../../../../hooks/usePopup"
import useAuthentication from "@hooks/useAuthentication"


function AddOrEdit({ data, setData, setSuccess, success }: { data: MasterTableDataType | null, success: boolean, setData: React.Dispatch<React.SetStateAction<MasterTableDataType | null>>, setSuccess: React.Dispatch<React.SetStateAction<boolean>> }) {
  const pageTitle = "Insurance Price Reference"
  const { control, reset, handleSubmit, setValue, getValues, resetField,watch } = useForm()
  const [insType, setInsType] = useState<number | null>(2)
  const { showSnackbar } = usePopup();
  const {user} = useAuthentication()
  const selectedNetwork = watch("insNetwork")
  const onSubmit = (formdata: any) => {
    const saveParams: SaveReference = {
      id: data?.id ?? null,
      insType: formdata?.insType?.id,
      insName: formdata?.insurance?.id,
      insGroup: formdata?.inGroup?.id || null,
      insPlan: formdata?.inPlan?.id || null,
      networkCode: formdata?.insNetwork?.id,
      cptGrp: formdata?.cptGroup?.cptGroupId,
      factor: formdata?.factor,
      createdById: Number(user?.userId),
      clinicId,
      approvalrequired: formdata?.approvalRequired,
      isCommon: formdata?.common,
      isexcluded: formdata?.isExcluded,
      effectiveFromDate: formdata?.effectiveFromDate
    }
    saveReference(saveParams)
  }

  const { mutate: saveReference, isLoading } = useMutation(saveInsurancePriceMaster, {
    onSuccess: (result) => {
      if (result.responseIndicator == "success") {
        setSuccess(!success)
        reset({
          insType: null,
          insurance: null,
          inGroup: null,
          insNetwork: null,
          inPlan: null,
          cptGroup: null,
          factor: null,
          effectiveFromDate: null,
          common: false,
          isExcluded: false,
          approvalRequired: false
        })

        showSnackbar({
          message: result.responseMessage,
          open: true,
          variant: "success",
          duration: 3000,
        });
      } else {
        showSnackbar({
          message: result.responseMessage,
          open: true,
          variant: "warning",
          duration: 3000,
        });
      }
    },
    onError: () => {
      showSnackbar({
        message: "Something went wrong",
        open: true,
        variant: "error",
        duration: 3000,
      });
    }
  })
  const { mutate: getInsuranceType, data: InsuranceTypeList } = useMutation(getAllInsuraceType);
  const { mutate: getInsuranceByType, data: ReceiverList } = useMutation(getAllInsurance)
  const { mutate: getInsuranceByType2, data: PayerList } = useMutation(getAllInsurance)
  const { mutate: getPlan, data: planList } = useMutation(getInsPlanService)
  const { mutate: getInusuranceNetwork, data: nteworkList } = useMutation(getNetwork)
  const { mutate: getcptGroups, data: groupList } = useMutation(getAllCptGrpups)


  const clearOtherField = (fieldsName: string[]) => {
    fieldsName.forEach((field) => {
      resetField(field);
    });
  };

  const OnTypeChange = (e: FormOnChangeEventType) => {
    const value = e?.target?.value
    setInsType(value?.id)
    getInsuranceByType(value?.id);
    clearOtherField(["insurance", "inGroup", "insNetwork", "inPlan", "cptGroup"]);
  }

  const ReceiverChange = (e: FormOnChangeEventType) => {
    const value = e?.target?.value
    console.log(getValues("insType")?.id);
    
    getValues("insType")?.id == 1 && getInsuranceByType2(2);
    getPlan({
      clinicId: clinicId,
      insName: value?.id,
      insType: getValues("insType")?.id as number,
    })

    getInusuranceNetwork({
      clinicId: clinicId,
      insName: getValues("insurance")?.id as number,
      insType: getValues("insType")?.id as number,
    })

    reset({
      ...getValues(),
      inGroup: null,
      insNetwork: null, inPlan: null, cptGroup: null
    })

  }

  const PayerChange = (e: FormOnChangeEventType) => {
    const value = e?.target?.value
    getPlan({
      clinicId: clinicId,
      insName: getValues("insurance")?.id as number,
      insType: getValues("insType")?.id as number,
      inGroupId: value?.id ?? null,
    })

    getInusuranceNetwork({
      clinicId: clinicId,
      insName: getValues("insurance")?.id as number,
      insType: getValues("insType")?.id as number,
      inGroupId: value?.id ?? null
    })
    clearOtherField(["insNetwork", "inPlan", "cptGroup"]);
  }

  const onNetworkChange = (e: FormOnChangeEventType) => {
    const value = e?.target?.value
    getPlan({
      clinicId: clinicId,
      insName: getValues("insurance")?.id as number,
      insType: getValues("insType")?.id as number,
      inGroupId: getValues("inGroup")?.id as number ?? null,
      insNetworkId: value?.id ?? null
    })
    clearOtherField(["inPlan", "cptGroup"]);

  }

    const onApprovalChange=()=>{
        setValue("isExcluded",false)
    }
    const onExcludedChange=()=>{
        setValue("approvalRequired",false)
    }


  

  useEffect(() => {
    getInsuranceType()
    getcptGroups()
    if (data) {
      data?.insTypeId == 1 ?
        (setInsType(1), getInsuranceByType(1), getInsuranceByType2(2)) :
        setInsType(2), getInsuranceByType(2)
      data?.insNetworkId != null &&
        getInusuranceNetwork({
          clinicId: clinicId,
          insName: data?.insNameId as number,
          insType: data?.insTypeId as number,
          inGroupId: data?.insGroupId ? data?.insGroupId as number : null
        })
      data?.insPlanId != null &&
        getPlan({
          clinicId: clinicId,
          insName: data?.insNameId as number,
          insType: data?.insTypeId as number,
          inGroupId: data?.insGroupId ? data?.insGroupId as number : null,
          insNetworkId: data?.insNetworkId ? data?.insNetworkId as number : null
        })
      reset({
        factor: data?.factor,
        effectiveFromDate: data?.effectiveFromDate,
        common: data?.common,
        isExcluded: data?.isExcluded,
        approvalRequired: data?.approvalRequired
      });
      data?.insTypeId && setValue("insType", { id: data?.insTypeId, name: data?.insType })
      data?.insNameId && setValue("insurance", { id: data?.insNameId as number, name: data?.insName as string });
      data?.insGroupId && setValue("inGroup", { id: data?.insGroupId as number, name: data?.insGroup as string });
      data?.insNetworkId && setValue("insNetwork", { id: data?.insNetworkId, name: data?.insNetwork })
      data?.cptGrpId && setValue("cptGroup", { cptGroupId: data?.cptGrpId, cptGroupName: data?.cptGrp })
      data?.insPlanId && console.log("insPlanId", data?.insPlanId); console.log("insPlanName", data?.insPlan);
      setValue("inPlan", { id: data?.insPlanId, name: data?.insPlan as string });
    }
  }, [data]);



  return (
    <div className="p-3">
      <form onSubmit={handleSubmit(onSubmit)}>
        <Paper>
          <div className="flex justify-between items-center p-2">
            <div>
              <Typography variant="h6" className="p-3">
                {`${data != null ? "Edit" : "Add"} ${pageTitle}`}
              </Typography>
            </div>
            <div className="flex gap-2">

              <Button
                disabled={isLoading}
                color="error"
                type="reset"
                startIcon={<Close />}
                onClick={() => {
                  setInsType(2)
                  setData(null)
                  reset({
                    insType: null,
                    insurance: null,
                    inGroup: null,
                    insNetwork: null,
                    inPlan: null,
                    cptGroup: null,
                    factor: null,
                    effectiveFromDate: null,
                    common: false,
                    isExcluded: false,
                    approvalRequired: false
                  })
                }}
              >
                reset
              </Button>
              <Button
                disabled={isLoading}
                type="submit"
                color="success"
                startIcon={
                  isLoading ? (
                    <CircularProgress size={20} color="success" />
                  ) : (
                    <Save />
                  )
                }
              >
                {data != null ? "update" : "Save"}
              </Button>
            </div>
          </div>
          <Divider />
          <div className="p-3 grid grid-cols-4 gap-3">
            <CustomFormField
              control={control}
              name="insType"
              element="autocomplete"
              fieldProps={{ label: "InsuranceType", }}
              rules={{ required: "Insurance is required", onChange: OnTypeChange }}
              autocompleteProps={{
                isOptionEqualToValue: (option, value) => option.id == value.id,
                getOptionLabel: (option) => option.name,
              }}
              options={InsuranceTypeList?.response ?? []}
            />

            <CustomFormField
              control={control}
              name="insurance"
              element="autocomplete"
              fieldProps={{ label: "Receiver" }}
              rules={{ required: "Receiver is required", onChange: ReceiverChange }}
              options={ReceiverList?.response ?? []}
              autocompleteProps={{
                isOptionEqualToValue: (option, value) => option.id == value.id,
                getOptionLabel: (option) => option.name,
              }}
            />
            {

              insType == 1 &&

              <CustomFormField
                control={control}
                name="inGroup"
                element="autocomplete"
                fieldProps={{ label: "Payer" }}
                rules={{ required: false, onChange: PayerChange }}
                options={PayerList?.response ?? []}
                autocompleteProps={{
                  isOptionEqualToValue: (option, value) => option.id == value.id,
                  getOptionLabel: (option) => option.name,
                }}
              />}


            <div className="">
              <CustomFormField
                control={control}
                name="insNetwork"
                element="autocomplete"
                fieldProps={{ label: "network" }}
                rules={{ onChange: onNetworkChange }}
                options={nteworkList?.response ?? []}
                autocompleteProps={{
                  isOptionEqualToValue: (option, value) => option.id == value.id,
                  getOptionLabel: (option) => option.name,
                }}
              />
            </div>
            <div className={Boolean(selectedNetwork?.id) ?  "hidden" : "block"}>
              <CustomFormField
                control={control}
                name="inPlan"
                element="autocomplete"
                fieldProps={{ label: "plan" }}
                rules={{ required:Boolean(selectedNetwork?.id) ? false : "plan is required" }}
                options={planList?.response ?? []}
                autocompleteProps={{
                  isOptionEqualToValue: (option, value) => option?.id == value?.id,
                  getOptionLabel: (option) => option?.name,
                }}
              />
            </div>
            <div className="">
              <CustomFormField
                control={control}
                name="cptGroup"
                element="autocomplete"
                fieldProps={{ label: "cpt group" }}
                rules={{ required: false }}
                options={Array.isArray(groupList?.response) ? groupList?.response : []}
                autocompleteProps={{
                  isOptionEqualToValue: (option, value) => option?.cptGroupId == value?.cptGroupId,
                  getOptionLabel: (option) => option?.cptGroupName,
                }}
              />
            </div>
            <div className="">
              <CustomFormField
                control={control}
                name="factor"
                element="input"
                fieldProps={{ label: "factor" }}
                rules={{ required: "false" }}
              />
            </div>
            <div className="">
              <CustomFormField
                control={control}
                name="effectiveFromDate"
                element="datepicker"
                fieldProps={{ label: "effective Date" }}
                rules={{ required: "false" }}
              />
            </div>
            <div className="">
              <CustomFormField
                control={control}
                name="common"
                element="checkbox"
                fieldProps={{ label: "Common" }}
                rules={{ required: false }}
              />
            </div>
            <div className="">
              <CustomFormField
                control={control}
                name="approvalRequired"
                element="checkbox"
                fieldProps={{ label: "approvalRequired" }}
                rules={{ required: false ,onChange:onApprovalChange}}
              />
            </div>
            <div className="">
              <CustomFormField
                control={control}
                name="isExcluded"
                element="checkbox"
                fieldProps={{ label: "isExcluded" }}
                rules={{ required: false ,onChange: onExcludedChange}}
              />
            </div>

          </div>
        </Paper>
      </form>
    </div>
  )
}

export default AddOrEdit
